import React, { useState } from 'react';
import './OTPCode.scss';
import UserAnalytic from '../../helpers/UserAnalytic';

const OTPCodeItem = ({
    value, index
}) => {
    return (
        <div className="ocm-item">
            {index}
        </div>
    )
}

export const IS_NUMBER = /^[0-9\ ]+$/;

const OTPCode = ({
    digits = 6,
    onChange
}) => {
    const [value, setValue] = useState('');
    const [isComplete, setCompleteStatus] = useState(false);

    const handleOnChange = (value) => {
        let complete = false;
        if (value == '' || IS_NUMBER.test(value) === true) {
            setValue(value);
            if (value.length === digits && isComplete === false) {
                setCompleteStatus(true);
                complete = true;
                UserAnalytic.event({
                    category: 'user_security',
                    action: 'OTP Added',
                });
            }
            else if (value.length != digits && isComplete === true) {
                setCompleteStatus(false);
                complete = false;
                UserAnalytic.event({
                    category: 'user_security',
                    action: 'OTP Removed',
                });
            }
        }
        if (onChange) onChange(value, complete);
    };
    return (
        <div className="otp-code-module">
            <input
                onChange={(e) => handleOnChange(e.target.value)}
                value={value}
                maxLength={digits}
            />
        </div>
    );
};

export default OTPCode;